// Meta API for server metadata endpoints
export class MetaAPI {
  /**
   * @param {HttpClient} http
   */
  constructor(http) {
    this.http = http;
  }

  /**
   * Get server version information
   * @returns {Promise<{version: string}>}
   */
  async getVersion() {
    return this.http.get("/meta/version");
  }

  /**
   * Get status of all initialized agents
   * @returns {Promise<Array<{name: string, is_active: boolean, provider: string, model: string, prompt_id?: string, system_prompt_len: number}>>}
   */
  async getAgentsStatus() {
    return this.http.get("/meta/agents-status");
  }

  /**
   * Trigger reload of agent configurations
   * @returns {Promise<{status: string}>}
   */
  async reloadAgents() {
    return this.http.post("/meta/reload-agents");
  }
}
